import { getCurrencyFormatConfig } from './formatter';
export const getMoney = (amount, currency) => {
    const value = roundPrice(Number(amount), currency);
    return {
        value,
        amount: value,
        currency,
    };
};
export const getCurrencyDecimals = (currencyCode) => getCurrencyFormatConfig(currencyCode)?.decimalDigits ?? 2;
export const roundPrice = (amount, currencyCode) => amount.toFixed(getCurrencyDecimals(currencyCode));
